import React, { Component } from "react";
import Loader from "react-loader-spinner";
import auth from "../../components/auth";
import { url } from "../../components/url";
import "./Reset.css";

class Reset extends Component {
  state = {
    password: "",
    confirm: "",
    isShowLoader: false
  };

  setPswd = val => {
    this.setState({ password: val.target.value });
  };

  setConfirm = val => {
    this.setState({ confirm: val.target.value });
  };

  showLoader = event => {
    event.preventDefault();
    if (!event.target.checkValidity()) {
      // form is invalid! so we do nothing
      // alert('not valid')
      this.setState({ displayErrors: true });
      return;
    } else {
      this.setState({ displayErrors: false });
      this.setState({ isShowLoader: true });
      setTimeout(() => {
        this.submitForm();
      }, 1000);
    }
  };

  submitForm = () => {
    if (this.state.confirm !== this.state.password) {
      this.setState({ isShowLoader: false });
      alert("passwords do not match");
    } else if (this.state.password.length < 4) {
      this.setState({ isShowLoader: false });
      alert("password must have at least 4 characters");
    } else {
      this.setState({ isShowLoader: false });
      this.resetPasswordHandler();
    }
  };

  logout = () => {
    auth.logout(() => {
      localStorage.removeItem("BRHMMobileToken");
    });
    this.props.history.push("/");
  };

  resetPasswordHandler = () => {
    let formData = JSON.stringify({
      name: "resetPassword",
      param: {
        password: this.state.password
      }
    });

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.BRHMMobileToken
      },
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(res => {
        if (res.hasOwnProperty("error")) {
          alert(res.error.message);
          if (res.error.message === "Expired token") {
            // this.logout();
          }
        } else if (res.response === true) {
          alert("Your password has been changed!");
          this.logout();
        } else {
          console.log(res);
        }
      })
      .then(this.setState({ isShowLoader: false }))
      .catch(error => {
        this.setState({ isShowLoader: false });
        if (error + "" === "TypeError: Failed to fetch") {
          alert(
            "Please check if the device is connected to stable cellular data plan or WiFi."
          );
        }
      });
  };

  render() {
    const { displayErrors } = this.state;

    return (
      <div style={styles.main}>
        <form
          style={styles.container}
          onSubmit={this.showLoader}
          className={displayErrors ? "displayErrors" : "nodisplayErrors"}
          noValidate
        >
          <input
            type="password"
            placeholder="New Password"
            onChange={this.setPswd}
            autoComplete="new-password"
            style={styles.input}
            required
          />

          <input
            type="password"
            placeholder="Confirm Password"
            onChange={this.setConfirm}
            autoComplete="new-password"
            style={styles.input}
            required
          />

          {this.state.isShowLoader ? (
            <div style={{ alignSelf: "center", marginTop: 10 }}>
              <Loader type="ThreeDots" color="#8cab49" height="40" width="40" />
            </div>
          ) : (
            <button type="submit" style={styles.button}>
              Save
            </button>
          )}
        </form>
      </div>
    );
  }
}

export default Reset;

const styles = {
  main: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    flex: 1
  },

  container: {
    display: "flex",
    flexDirection: "column",
    marginTop: 10,
    width: "50%",
    backgroundColor: "#eee",
    height: "100%"
  },

  button: {
    marginTop: 20,
    width: "30%",
    height: "40px",
    backgroundColor: "#8cab49",
    borderColor: "transparent",
    color: "white",
    alignSelf: "center",
    outline: "none"
  },

  input: {
    display: "flex",
    borderStyle: "solid",
    borderRadius: 9,
    marginBottom: 4,
    height: 40,
    backgroundColor: "white",
    textDecorationLine: "none",
    outline: "none",
    paddingLeft: 10,
    width: "90%",
    alignSelf: "center"
  }
};
